import { createRoot } from 'react-dom/client';
import domReady from '@wordpress/dom-ready';
import Dashboard from './admin/pages/Dasboard';

import './style.scss';

domReady( () => {
	const rootElement = document.getElementById( 'boilpress-root' );
	if ( ! rootElement ) return;

	const root = createRoot( rootElement );
	root.render( <Dashboard /> );
} );
